import type { MapViewState } from "../map/presets";

interface MapOverlayControlsProps {
  mapViewState: MapViewState;
  onAerialOnly: () => void;
  onClearOverlays: () => void;
  onRestoreLens: () => void;
}

export function MapOverlayControls({
  mapViewState,
  onAerialOnly,
  onClearOverlays,
  onRestoreLens,
}: MapOverlayControlsProps) {
  const isCustom = mapViewState.kind === "custom";
  const label = isCustom ? (mapViewState as { kind: "custom"; label: string }).label : null;

  return (
    <div className="map-overlay-controls">
      {isCustom && label && (
        <span className="map-view-status" role="status" aria-live="polite">
          <span className="map-view-status-dot" />
          {label}
        </span>
      )}
      <div className="map-overlay-actions">
        {isCustom ? (
          <button
            onClick={onRestoreLens}
            aria-label="คืนเลนส์เริ่มต้นตามเลนส์ปัจจุบัน"
            title="คืนเลนส์เดิม"
          >
            RESTORE LENS
          </button>
        ) : (
          <>
            <button
              onClick={onAerialOnly}
              data-basemap="satellite-esri"
              aria-label="สลับเป็นภาพถ่ายดาวเทียมอย่างเดียว — ปิดเลเยอร์ข้อมูลทั้งหมด"
              title="ดูภาพถ่ายดาวเทียมอย่างเดียว"
            >
              AERIAL
            </button>
            <button
              onClick={onClearOverlays}
              aria-label="ลบเลเยอร์ที่แสดงอยู่ทั้งหมด"
              title="ลบเลเยอร์ทั้งหมด"
            >
              CLEAR
            </button>
          </>
        )}
      </div>
    </div>
  );
}
